import { render, staticRenderFns } from "./InactiveCustomers.vue?vue&type=template&id=34d8902c&scoped=true&"
import script from "./InactiveCustomers.vue?vue&type=script&lang=js&"
export * from "./InactiveCustomers.vue?vue&type=script&lang=js&"
import style0 from "./InactiveCustomers.vue?vue&type=style&index=0&id=34d8902c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d8902c",
  null
  
)

export default component.exports